import { render } from "./HeaderAction.vue?vue&type=template&id=1bd32f75&ts=true"
import script from "./HeaderAction.vue?vue&type=script&lang=ts"
export * from "./HeaderAction.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__